import React from "react";

import ICONS from "constants/icons";

export const IntIcon = ({ name, ...props }) => {
  const IconComponent = ICONS[name];

  return <IconComponent {...props} />;
};
